/**
 * Build the Angular App
 *
 * @package:  Betta
 * @version:  2.1
 * @author:   Cyrill N KALITA
 */


/**
 * Require Angular
 */
window.angular = require('angular');

/**
 * Pull Angular Animate and Angular Resource into the JS Codebase
 */
require('angular-animate');
require('angular-loading-bar');
require('angular-resource');
require('angular-toarrayfilter');

/**
 * Pull Angular Directive for checklist models
 * @see : https://vitalets.github.io/checklist-model/
 */
require('checklist-model');

/**
 * Attach services to Application
 * Services allouw us to register API Resources
 */
require('./flsServices');

/**
 * Require Controllers
 * Controllers hangle JS logic
 */
require('./flsControllers');

/**
 * Require Config
 * Configulation
 */
require('./flsConfig');
